import { isMobile } from 'react-device-detect';

export class ScreenConfigRequestError extends Error {
    status: number;

    constructor(status: number) {
        super(`Screen config request failed with status ${status}`);
        this.name = 'ScreenConfigRequestError';
        this.status = status;
    }
}

export const fetchScreenConfig = (() => {
    let promise: Promise<any>;

    return () => {
        if (!promise) {
            const searchParams = new URLSearchParams(window.location.search);
            searchParams.set('MOBILE', isMobile ? 'yes' : 'no');

            promise = fetch(`/screen-config?${searchParams.toString()}`).then(
                (response) => {
                    if (!response.ok) {
                        throw new ScreenConfigRequestError(response.status);
                    }

                    return response.json();
                }
            );
        }

        return promise;
    };
})();
